<template>
  <div class="page-root">
    <!-- Ambient glow spots for visual density parity -->
    <div class="scene-glow glow-primary" style="top:15%;right:-50px"></div>
    <div class="scene-glow glow-accent" style="top:45%;left:-60px"></div>
    <div class="scene-glow glow-secondary" style="top:70%;right:-30px"></div>
    <div class="scene-glow glow-bottom" style="bottom:80px;left:50%;transform:translateX(-50%)"></div>

    <HeaderBar />
    <Hero />
    <Banner />
    <Cards />
    <Market />
    <News />
    <Partners />
  </div>
</template>

<script>
import HeaderBar from '@/components/HeaderBar.vue'
import Hero from '@/components/Hero.vue'
import Banner from '@/components/Banner.vue'
import Cards from '@/components/Cards.vue'
import Market from '@/components/Market.vue'
import News from '@/components/News.vue'
import Partners from '@/components/Partners.vue'

export default {
  name: 'HomePage',
  components: { HeaderBar, Hero, Banner, Cards, Market, News, Partners }
}
</script>

<style scoped>
.page-root {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 80px;
  min-height: 100vh;
  background: var(--bg-page);
}
</style>
